export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40364fbcb09450f0ca7122f4bfb1fcf2a846ef7a56&name=revalidateCommunity!'